import TypeToReducer from 'type-to-reducer';

import { normalize, schema } from 'normalizr';

import {
  GET_EMPLOYEES,
  SET_EMPLOYEES_PAGINATION,
  SET_EMPLOYEES_FILTERS,
  RESET_EMPLOYEES,
  TOGGLE_EMPLOYEE,
  GET_EMPLOYEE_REPORT_CSV,
} from 'employees/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const employee = new schema.Entity('employees');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'lastname', 'position', 'email'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { employees: {} },
  result: { employees: [] },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});
export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };
  const normalized = normalize({ employees: payload.records }, { employees: [employee] });
  return { ...state, isLoading: false, pagination, ...normalized };
};
export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    employees: {
      ...state.entities.employees,
      [meta.id]: { ...state.entities.employees[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    employees: {
      ...state.entities.employees,
      [meta.id]: { ...state.entities.employees[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    employees: {
      ...state.entities.employees,
      [payload.employee.id]: { ...payload.employee, isLoading: false },
    },
  },
});

export const getCSVPending = (state) => ({ ...state, isLoading: true });
export const getCSVFulfilled = (state) => ({ ...state, isLoading: false });
export const getCSVRejected = (state) => ({ ...state, isLoading: false });

const employeesListReducers = {
  [GET_EMPLOYEES]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [GET_EMPLOYEE_REPORT_CSV]: {
    [PENDING]: getCSVPending,
    [FULFILLED]: getCSVFulfilled,
    [REJECTED]: getCSVRejected,
  },
  [SET_EMPLOYEES_PAGINATION]: setPagination,
  [SET_EMPLOYEES_FILTERS]: setFilters,
  [RESET_EMPLOYEES]: reset,
  [TOGGLE_EMPLOYEE]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(employeesListReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/reducers/employees_list_reducers.js